






















































































import { namespace } from 'vuex-class';
import {
  Component,
  Prop,
  Vue
} from 'vue-property-decorator';
import { CART } from '@/store/types';
import {
  OrderDto,
  ProductAttributeInfo,
  ProductAttributeType
} from '@eurogast/hub-client-typescript';
import { NumberFormatter } from '@/services/NumberFormatter';
import { ProductUtil } from '@/services/ProductUtil';
import PreOrderSection from '@/cart-page/PreOrderSection.vue';
import { LinkUtil } from '@/services/LinkUtil';
import {
  Cart,
  CartItem
} from '@/services/cart/model/cart';
import MatomoEvents from '@/matomo/events/MatomoEvents';
import MatomoPageVisit from '@/matomo/MatomoPageVisit';
import {
  Step,
  Steps
} from '@/cart-page/header/Step';

const cart = namespace(CART);
@Component({
  components: { PreOrderSection }
})
export default class ConfirmationStepView extends Vue {
  @cart.State('cart')
  public cart: Cart;

  @cart.State('lastSuccessfulOrder')
  public lastOrder: OrderDto;

  @Prop({ required: false, default: null })
  public order: OrderDto;

  private preOrderOpen = true;

  get orderId() {
    return this.currOrder.id;
  }

  get customerOrderId() {
    return this.currOrder.customerOrderId;
  }

  get positions() {
    return this.currOrder.orderItems.length;
  }

  get totalSum() {
    let sum = 0.0;
    this.currOrder.orderItems.forEach((it) => {
      if (it.mostAccurateRowTotal) {
        sum += it.mostAccurateRowTotal;
      }
    });
    return NumberFormatter.formatPrice(sum);
  }

  get showPrice() {
    return this.totalSum !== NumberFormatter.formatPrice(0.0);
  }

  get customerId() {
    return this.currOrder.customerId;
  }

  get userName() {
    return this.currOrder.userName;
  }

  get customerName() {
    return this.currOrder.deliveryAdress.companyLines.join(', ');
  }

  get orderDate() {
    return new Date(this.currOrder.creationTime).toLocaleString('de-AT');
  }

  get address() {
    return [
      this.currOrder.deliveryAdress.street,
      this.currOrder.deliveryAdress.postCode + ' ' + this.currOrder.deliveryAdress.city
    ];
  }

  get pdfUrl() {
    return `/my/orders/detail/pdf?order=${this.orderId}`;
  }

  get orderUrl() {
    return `/my/orders/detail/${this.orderId}`;
  }

  get deliveryDate() {
    if (this.currOrder.deliverySlotDate && this.currOrder.deliverySlotDate !== '') {
      return new Date(this.currOrder.deliverySlotDate).toLocaleDateString('de-AT');
    }
    return this.$t('cartPage.confirmationStep.deliveryDateUnknown');
  }

  get deliveryTime() {
    return this.currOrder.deliverySlotTime;
  }

  get emails() {
    if (this.currOrder.confirmationEmails) {
      return this.currOrder.confirmationEmails.split(';');
    }

    return [this.$t('cartPage.confirmationStep.noConfirmationMailAvailable')];
  }

  get unloadingArea() {
    return this.currOrder.unloadingArea;
  }

  get comment() {
    return this.currOrder.comment;
  }

  get preOrderItems() {
    return this.cart.items.filter((it: CartItem) => it.product.attributes.some(
      (attr: ProductAttributeInfo) => attr.key === ProductAttributeType.Bestellartikel
    ));
  }

  get localeDeliveryWeekday() {
    if (this.currOrder.deliverySlotDate && this.currOrder.deliverySlotDate !== '') {
      return new Date(this.currOrder.deliverySlotDate).toLocaleDateString(this.$i18n.locale, { weekday: 'long' });
    }
    return '';
  }

  public mounted() {
    MatomoPageVisit.withDocumentTitle(this.$t(Steps.getName(Step.CONFIRMATION)).toString()).publishPageVisit();
  }

  public trackOrderConfirmationDownload() {
    MatomoEvents.forOrder.downloadConfirmation.publish();
  }

  public findImageUrl(item: CartItem): string {
    return LinkUtil.getProductImageUrl(item.product);
  }

  public togglePreOrderOpen() {
    this.preOrderOpen = !this.preOrderOpen;
  }

  public getAmountBySku(sku: string) {
    return ProductUtil.getAmountBySku(this.cart.items, sku);
  }

  public getBaseAmountBySku(sku: string) {
    return ProductUtil.getBaseAmountBySku(this.cart.items, sku);
  }

  public getBasePriceBySku(sku: string) {
    return ProductUtil.getStoragePriceBySku(this.cart.items, sku);
  }

  public getSumBySku(sku: string) {
    return ProductUtil.getSumBySku(this.cart.items, sku);
  }

  get currOrder() {
    if (this.order === null) {
      return this.lastOrder;
    }
    return this.order;
  }

}
